/**
 * Discrete gradient scrim painted behind the fixed prompt bar so it stays legible over
 * arbitrary scrolling content. Sits at the viewport bottom, below the bar (z-20 < the bar's
 * z-30), and is non-interactive.
 *
 * The veil contrasts with the bar in each theme so it pops in both:
 * - light: a soft dark veil (a white bar reads against it),
 * - dark:  a soft light lift (a dark `#1E2022` bar reads against it).
 */
export const PromptBarScrim = () => (
  <div
    aria-hidden
    className="pointer-events-none fixed inset-x-0 bottom-0 z-20 h-32 bg-linear-to-t from-black/30 via-black/15 to-transparent dark:from-white/25 dark:via-white/10"
  />
);
